<template>
    <a-drawer :title="title" width="900" closable :visible.sync="show" @close="() => $emit('update:show', false)" :getContainer="() => $parent.$el">
        <a-descriptions title="基本资料" bordered :column="3" size="middle">
            <a-descriptions-item label="机构简称" :span="2">
                {{ detail.name }}
            </a-descriptions-item>
            <a-descriptions-item label="ID">
                {{ detail.id }}
            </a-descriptions-item>
            <a-descriptions-item label="会员级别" :span="3">
                {{ detail.level | fmtUserLevel }}
                <span v-if="detail.lvexp">[{{ detail.lvexp }}] 到期</span>
                <span v-else>长期有效</span>
            </a-descriptions-item>
            <a-descriptions-item label="标签" :span="3">
                {{ detail.tags }}
            </a-descriptions-item>
            <a-descriptions-item label="机构全称" :span="2">
                {{ detail.cert.name }}
            </a-descriptions-item>
            <a-descriptions-item label="信用识别号">
                {{ detail.cert.sno }}
            </a-descriptions-item>
            <a-descriptions-item label="地址" :span="2">
                {{ detail.addr }}
            </a-descriptions-item>
            <a-descriptions-item label="手机号">
                {{ detail.mob }}
            </a-descriptions-item>
            <a-descriptions-item label="邮箱" :span="2">
                {{ detail.email }}
            </a-descriptions-item>
            <a-descriptions-item label="微信号">
                {{ detail.wxkey }}
            </a-descriptions-item>
            <a-descriptions-item label="图标" :span="3">
                <div v-if="detail.logo" :style="{ width: '100px', height: '100px' }">
                    <img :src="detail.logo" :style="{ width: '100%', height: '100%' }" />
                </div>
                <span v-else>未上传</span>
            </a-descriptions-item>
            <a-descriptions-item label="机构性质">
                {{ detail.nature }}
            </a-descriptions-item>
            <a-descriptions-item label="注册日期">
                {{ detail.rdate }}
            </a-descriptions-item>
            <a-descriptions-item label="法人或负责人">
                {{ detail.legal }}
            </a-descriptions-item>
            <a-descriptions-item label="注册资金">
                {{ detail.rcapt }}
            </a-descriptions-item>
            <a-descriptions-item label="主管单位" :span="2">
                {{ detail.manager }}
            </a-descriptions-item>
            <a-descriptions-item label="营业范围" :span="3">
                {{ detail.scope }}
            </a-descriptions-item>
            <a-descriptions-item label="简介摘要" :span="3">
                {{ detail.memo }}
            </a-descriptions-item>
            <a-descriptions-item label="机构简介" :span="3">
                {{ detail.intro }}
            </a-descriptions-item>
            <a-descriptions-item label="影响力" :span="3">
                {{ detail.influ }}
            </a-descriptions-item>
            <a-descriptions-item label="专业实力" :span="3">
                {{ detail.stren }}
            </a-descriptions-item>
        </a-descriptions>
        <a-divider />
        <div class="ant-descriptions-title">机构图片</div>
        <a-row :gutter="[10, 10]">
            <a-col :span="4" v-for="img in images" :key="img">
                <div :style="{ width: '100px', height: '100px', border: '1px dashed grey', padding: '3px' }">
                    <img :src="img" :style="{ width: '100%', height: '100%' }" />
                </div>
            </a-col>
        </a-row>
        <a-divider />
        <a-descriptions title="账号信息" bordered :column="1" size="middle">
            <a-descriptions-item label="是否绑定微信">
                {{ item.wxmp.bind ? '已绑定' : '未绑定' }}
            </a-descriptions-item>
            <a-descriptions-item label="微信绑定码" v-if="!item.wxmp.bind">
                {{ item.wxmp.code || '未设置绑定码或已过期' }}
            </a-descriptions-item>
            <a-descriptions-item label="绑定码过期" v-if="!item.wxmp.bind && item.wxmp.code">
                {{ item.wxmp.time }}
            </a-descriptions-item>
            <a-descriptions-item label="绑定二维码" v-if="!item.wxmp.bind && item.wxmp.code">
                <a-button type="primary" icon="cloud-download" @click="execDownQr">下载二维码</a-button>
            </a-descriptions-item>
            <a-descriptions-item label="最近登录IP">
                {{ item.last.ip || '未登录' }}
            </a-descriptions-item>
            <a-descriptions-item label="最近登录时间">
                {{ item.last.time || '未登录' }}
            </a-descriptions-item>
            <a-descriptions-item label="是否锁定">
                {{ item.lock.flg ? '已锁定' : '未锁定' }}
            </a-descriptions-item>
            <a-descriptions-item label="锁定原因" v-if="item.lock.flg">
                {{ item.lock.cause }}
            </a-descriptions-item>
            <a-descriptions-item label="锁定时间" v-if="item.lock.flg">
                {{ item.lock.time }}
            </a-descriptions-item>
            <a-descriptions-item label="解锁时间" v-if="item.lock.flg">
                {{ item.lock.resume }}
            </a-descriptions-item>
        </a-descriptions>
    </a-drawer>
</template>
<script>
export default {
    props: {
        show: {
            type: Boolean,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        item: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            detail: {
                cert: {},
                wxmp: {},
                last: {},
                lock: {}
            }
        }
    },
    computed: {
        images() {
            return this.detail.imgs.split(',')
        }
    },
    mounted() {
        this.$http
            .get('/ums/unit/info/detail', {
                params: {
                    id: this.item.id
                }
            })
            .then(result => {
                this.detail = result.data
            })
    },
    methods: {
        execDownQr() {
            if (this.detail.wxmp.qrst) {
                window.open('https://mp.weixin.qq.com/cgi-bin/showqrcode?ticket=' + this.detail.wxmp.qrst)
            }
        }
    }
}
</script>
